module.exports = __webpack_public_path__ + "img/enemy_123_004.23ab7655.png";